import { useState } from 'react';

// Services

import ListsService from '../services/lists.service';

export default function CheckProvidersSuppliersOnList() {
    const [checkProvidersSuppliersOnListIsLoading, setCheckProvidersSuppliersOnListIsLoading] = useState(false);
    const [checkProvidersSuppliersOnListError, setCheckProvidersSuppliersOnListError] = useState(null);

    // Consult if the provider or supplier is on the international list

    const handleCheckProvidersSuppliersOnLists = async (name, handleSetisOnList) => {
        setCheckProvidersSuppliersOnListIsLoading(true);
        setCheckProvidersSuppliersOnListError(null);

        try {
            const data = {
                nombre: name,
                identifiacion: ""
            }

            const response = await ListsService.consultaListasInternacionales(data);
          
            if (response.data?.data?.codigoError === "0") {
                handleSetisOnList(false);
            }
            
            setCheckProvidersSuppliersOnListIsLoading(false);
 
        } catch(error) {
            setCheckProvidersSuppliersOnListIsLoading(false);

            if (error.response?.status === 400 && error.response?.data?.data?.codigoError === '1') {
                handleSetisOnList(true);
            } else {
                setCheckProvidersSuppliersOnListError(error.response?.data?.message || error.message);
            }
        }
    }

    return {
        checkProvidersSuppliersOnListIsLoading,
        checkProvidersSuppliersOnListError,
        handleCheckProvidersSuppliersOnLists,
    }
}
